import { jsx as n, jsxs as L } from "react/jsx-runtime";
import { useState as v, useRef as h, useEffect as M } from "react";
import { Button as T } from "../Button/index.js";
import { TrashFarFAIcon as k } from "../Icons/index.js";
import { SegmentedControl as D } from "../SegmentedControl/index.js";
import { Slider as F } from "../Slider/index.js";
import { c } from "../../RichText.module-BFZ-Trce.js";
import { TextField as x } from "../TextField/index.js";
import { Label as W } from "../Label/index.js";
import { S as O } from "../../Stack-Bh9dsrlC.js";
import { F as d } from "../../Flex-z_b6pdCM.js";
const P = [
  { label: "Small", value: "25%" },
  { label: "Medium", value: "50%" },
  { label: "Large", value: "100%" }
], Z = ({ editor: t }) => {
  const [w, I] = v({ top: 0, left: 0 }), [A, g] = v(null), a = h(null), i = h(!1), u = h(!1);
  if (M(() => {
    const e = () => {
      if (i.current || u.current) return;
      const s = t.view.dom.querySelectorAll("img");
      let o = null;
      if (s.forEach((r) => {
        const p = t.view.posAtDOM(r, 0);
        t.view.state.selection.from === p && (o = r);
      }), o) {
        g(o);
        const r = o.getBoundingClientRect();
        if (a.current) {
          const p = a.current.offsetWidth;
          I({
            top: r.bottom - 10,
            left: r.left + r.width / 2 - p / 2
          });
        }
      } else !i.current && !u.current && g(null);
    }, l = (s) => {
      if (a.current && a.current.contains(s.target))
        return;
      const o = s.target;
      if (o.tagName.toLowerCase() === "img") {
        const r = t.view.posAtDOM(o, 0);
        t.commands.setNodeSelection(r), e();
      } else
        g(null);
    }, m = (s) => {
      a.current && a.current.contains(s.target) && (i.current = !0, s.target.closest(`.${c.sliderRoot}`) !== null && (u.current = !0));
    }, b = () => {
      setTimeout(() => {
        i.current = !1, u.current = !1;
      }, 100);
    };
    return document.addEventListener("mousedown", m), document.addEventListener("mouseup", b), document.addEventListener("click", l), t.on("selectionUpdate", e), t.on("update", e), () => {
      document.removeEventListener("mousedown", m), document.removeEventListener("mouseup", b), document.removeEventListener("click", l), t.off("selectionUpdate", e), t.off("update", e);
    };
  }, [t]), !A) return null;
  const f = t.getAttributes("image").width || "100%", S = (e) => {
    switch (e) {
      case "25%":
        return 25;
      case "50%":
        return 50;
      case "75%":
        return 75;
      case "100%":
        return 100;
      default:
        return parseInt(e) || 100;
    }
  }, C = (e) => {
    e.stopPropagation();
  }, E = (e) => {
    e.stopPropagation(), u.current = !0;
  };
  return /* @__PURE__ */ n(
    "div",
    {
      ref: a,
      className: c.floatingImageToolbar,
      style: w,
      onClick: C,
      onMouseDown: (e) => e.stopPropagation(),
      children: /* @__PURE__ */ L(O, { children: [
        /* @__PURE__ */ n(W, { label: "Image scale" }),
        /* @__PURE__ */ n(d, { children: /* @__PURE__ */ n(
          D,
          {
            fullWidth: !0,
            size: "sm",
            data: P,
            value: f,
            onChange: (e) => {
              const l = e === "100%";
              t.chain().focus().updateAttributes("image", {
                width: e,
                className: l ? c.imageOriginalSize : c.image
              }).run();
            }
          }
        ) }),
        /* @__PURE__ */ n(d, { onMouseDown: E, children: /* @__PURE__ */ n(
          F,
          {
            value: S(f),
            min: 0,
            max: 100,
            step: 1,
            description: `${S(f)}%`,
            onChange: (e) => {
              const l = `${e}%`, m = e === 100;
              t.chain().focus().updateAttributes("image", {
                width: l,
                className: m ? c.imageOriginalSize : c.image
              }).run();
            }
          }
        ) }),
        /* @__PURE__ */ n(d, { children: /* @__PURE__ */ n(
          x,
          {
            w: "100%",
            label: "Alt text",
            value: t.getAttributes("image").alt || "",
            onChange: (e) => {
              t.chain().updateAttributes("image", { alt: e.target.value }).run();
            },
            onFocus: (e) => {
              e.stopPropagation(), i.current = !0;
            },
            onBlur: () => {
              setTimeout(() => {
                i.current = !1;
              }, 100);
            },
            onClick: (e) => {
              e.stopPropagation();
            }
          }
        ) }),
        /* @__PURE__ */ n(d, { children: /* @__PURE__ */ n(
          T,
          {
            w: "100%",
            variant: "tertiary",
            size: "md",
            onClick: () => t.chain().focus().deleteSelection().run(),
            danger: !0,
            leftSection: /* @__PURE__ */ n(k, {}),
            children: "Delete image"
          }
        ) })
      ] })
    }
  );
};
export {
  Z as FloatingImageToolbar
};
